import { STAY_ICON_VERSION } from "../../stays/lib/stay-type-icon";

// 3D clay subcategory icons (mirrored from the mobile app). PNGs live in
// apps/majourneys/public/images/subcategories/sub-<slug>.png. Keep this set in
// sync with `subcategoryIcons` in packages/assets/src/images/index.ts.
export const CLAY_ICON_SLUGS = new Set([
  "air",
  "buggy",
  "calligraphy-painting",
  "camel",
  "camp",
  "city-tour",
  "cooking-class",
  "crafts",
  "day-trips",
  "diving",
  "horse",
  "jet-ski",
  "pottery",
  "quad",
  "shows",
  "villa",
  "water",
  "weaving",
  "zellige",
]);

// Bumped whenever a sub-*.png is redrawn. The images are cached for 30 days
// (see stay-type-icon.ts), so without a new query string returning visitors
// keep the old drawing for a month. 2026-09-26: camel, horse, quad, buggy and
// air redrawn.
export const SUB_ICON_VERSION = "2026-09-26";

// Category slugs that differ from the icon filename.
const CLAY_ICON_ALIAS: Record<string, string> = { jetski: "jet-ski" };

/** The icon file's key for a category slug, or the slug itself. */
export function clayIconKey(slug: string): string {
  const key = slug.toLowerCase().replace(/\s+/g, "-");
  return CLAY_ICON_ALIAS[key] ?? key;
}

/**
 * The clay icon for a category, or null when it has none. Used by the
 * category rail and by the booking sheet's small confirmation, where the
 * icon rides the progress line.
 */
export function categoryIconSrc(slug: string | null | undefined): string | null {
  if (!slug) return null;
  const key = clayIconKey(slug);
  if (!CLAY_ICON_SLUGS.has(key)) return null;
  // Camp was redrawn with the stay types, so it carries their version.
  return `/images/subcategories/sub-${key}.png?v=${key === "camp" ? STAY_ICON_VERSION : SUB_ICON_VERSION}`;
}

// 3D icons on L'Épicurien's Dinner / Bottle service lounge cards, keyed by
// `tablePolicy.serviceGroups[].icon`. Files in public/images/services/.
const SERVICE_ICON_VERSION = "2026-11-05b";
const SERVICE_ICON_KEYS = new Set(["dinner", "bottle-service"]);

/** The card icon for a restaurant service group key, or null. */
export function serviceIconSrc(key: string): string | null {
  return SERVICE_ICON_KEYS.has(key) ? `/images/services/${key}.png?v=${SERVICE_ICON_VERSION}` : null;
}
